import React from 'react';

import { Routes, Route, Navigate } from 'react-router-dom';

import HomePage from '../pages/home/HomePage';
import CategoryPage from 'pages/category/CategoryPage';
import SectionPage from 'pages/section/SectionPage';
import ArticlePage from 'pages/article/ArticlePage';
import DoubtFormPage from 'pages/doubt-form/DoubtFormPage';
import TermsPage from 'pages/terms/TermsPage';
import PoliciesPage from 'pages/policies/PoliciesPage';

const RouteList = () => (
	<Routes>
		<Route exact path="/" element={<HomePage />} />
		<Route exact path="/categoria" element={<CategoryPage />} />
		<Route exact path="/secao/:type/:id" element={<SectionPage />} />
		<Route exact path="/artigo/:type/:url" element={<ArticlePage />} />
		<Route exact path="/enviar-duvida" element={<DoubtFormPage />} />
		<Route exact path="/politicas-de-privacidade" element={<PoliciesPage />} />
		<Route exact path="/termos-de-uso" element={<TermsPage />} />
        <Route path="*" element={<Navigate to="/" replace />}
    />
	</Routes>
);

export default RouteList;